var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHotelFinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 38C29.4934 38 38 29.4934 38 19C38 8.50659 29.4934 0 19 0C8.50659 0 0 8.50659 0 19C0 29.4934 8.50659 38 19 38ZM25.296 14.2V11.768H28.528V8.632H11.344V11.768H21.072V14.2H11.344V17.144H20.912C20.7413 17.9973 20.3893 18.616 19.856 19C19.3227 19.384 18.512 19.64 17.424 19.768C16.336 19.8747 14.6507 19.928 12.368 19.928V24.184C12.368 26.5093 12.9653 28.28 14.16 29.496C15.3547 30.712 17.0827 31.32 19.344 31.32C21.52 31.32 23.1947 30.7547 24.368 29.624C25.5413 28.472 26.1493 26.8187 26.192 24.664H22.032C22.032 25.7093 21.8187 26.5093 21.392 27.064C20.9653 27.5973 20.272 27.864 19.312 27.864C18.3093 27.864 17.5947 27.576 17.168 27C16.7627 26.424 16.56 25.6347 16.56 24.632V22.936C19.248 22.936 21.2533 22.4773 22.576 21.56C23.92 20.6427 24.7627 19.1707 25.104 17.144H28.528V14.2H25.296Z",
    fill: "#ECECEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotelFinance);
export default __webpack_public_path__ + "static/media/Hotel Finance.784e10ccecaa19f22da4fc596f2a5460.svg";
export { ForwardRef as ReactComponent };